"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Chats = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M15.433 12.2a5.713 5.713 0 00-4.464-8.155A5.715 5.715 0 10.566 8.772l-.52 1.765a1.143 1.143 0 001.42 1.42l1.765-.52c.567.272 1.174.45 1.799.525a5.714 5.714 0 007.738 2.904l1.765.519a1.143 1.143 0 001.42-1.419l-.52-1.765zm-1.16.106l.584 1.983-1.983-.583a.571.571 0 00-.429.045 4.575 4.575 0 01-6.133-1.778 5.708 5.708 0 005.023-6.705 4.57 4.57 0 012.982 6.606.572.572 0 00-.044.431z",
  className: "fill"
}));
var _default = exports.default = Chats;